module.exports = __webpack_public_path__ + "img/game_gsport_x.8ec0dd7.jpg";